import React, { useEffect } from "react";
import { Grid, Card, Switch, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const ChatbotFlowPermissionCard = (props) => {
  const { modules, setModules } = props;
  useEffect(() => {
    if (modules.ChatbotFlow_view === undefined) {
      setModules((prevModules) => ({
        ...prevModules,
        ChatbotFlow_view: true,
      }));
    }
  }, [modules, setModules]);

  const handleChatbotFLowViewChange = (event) => {
    const isChatbotFlowViewEnabled = event.target.checked;
    setModules({
      ...modules,
      ChatbotFlow_view: isChatbotFlowViewEnabled,
    });
  };

  return (
    <>
      <Card sx={{ minWidth: 275, boxShadow: 3, width: "inherit" }}>
        <MDBox p={2}>
          <Grid container spacing={1}>
            <Grid item lg={12} md={12} xs={12} container alignItems="center">
              <MDTypography
                color="dark"
                display="block"
                variant="subtitle2"
                fontWeight="bold"
                sx={{ flex: 1 }}
              >
                Design Bot Module
              </MDTypography>

              <Tooltip
                title={`${
                  modules.ChatbotFlow_view ? "Disable" : "Enable"
                } Design Bot module`}
                placement="top"
              >
                <Switch
                  checked={modules.ChatbotFlow_view}
                  onChange={handleChatbotFLowViewChange}
                />
              </Tooltip>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </>
  );
};

export default ChatbotFlowPermissionCard;
